import * as React from 'react'
import { AlertCircle, Inbox } from 'lucide-react'
import { cn } from '../../lib/cn'
import { Button } from './button'

function FeedbackState({
  icon: Icon,
  tone = 'neutral',
  title,
  description,
  action,
  actionLabel,
  onAction,
  className,
}) {
  const toneClasses = {
    neutral: 'border-sgez-border bg-sgez-background text-sgez-muted',
    danger: 'border-red-200 bg-red-50 text-red-600',
  }

  return (
    <div className={cn('flex flex-col items-center justify-center px-4 py-10 text-center', className)}>
      <div className={cn('mb-3 inline-flex h-10 w-10 items-center justify-center rounded-full border', toneClasses[tone])}>
        <Icon className="h-5 w-5" aria-hidden="true" />
      </div>
      <div className="text-sm font-semibold text-sgez-ink">{title}</div>
      {description ? (
        <p className="mt-1 max-w-md text-sm leading-6 text-sgez-muted">{description}</p>
      ) : null}
      {action ? <div className="mt-4">{action}</div> : null}
      {!action && actionLabel && onAction ? (
        <Button type="button" variant={tone === 'danger' ? 'sgezOutline' : 'sgez'} size="sm" className="mt-4" onClick={onAction}>
          {actionLabel}
        </Button>
      ) : null}
    </div>
  )
}

function EmptyState({
  icon = Inbox,
  title = '표시할 항목이 없습니다',
  description,
  action,
  actionLabel,
  onAction,
  className,
}) {
  return (
    <FeedbackState
      icon={icon}
      title={title}
      description={description}
      action={action}
      actionLabel={actionLabel}
      onAction={onAction}
      className={className}
    />
  )
}

function ErrorState({
  icon = AlertCircle,
  title = '잠시 연결이 원활하지 않습니다',
  description = '데이터를 불러오지 못했습니다. 네트워크 상태를 확인한 뒤 다시 시도해 주세요.',
  actionLabel = '다시 시도',
  onAction,
  className,
}) {
  return (
    <FeedbackState
      icon={icon}
      tone="danger"
      title={title}
      description={description}
      actionLabel={onAction ? actionLabel : undefined}
      onAction={onAction}
      className={className}
    />
  )
}

export { EmptyState, ErrorState }
